(() => {
  const enhanceBundle = (root) => {
    const bottleLabel = root.dataset.bottleLabel || '';
    const priceLabel = root.dataset.priceLabel || '';
    const originalPriceLabel = root.dataset.originalPriceLabel || '';
    const singleOfferLabel = root.dataset.singleOfferLabel || '';

    root.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
      const title = bar.querySelector('.kaching-bundles__bar-title');
      const subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      const price = bar.querySelector('.kaching-bundles__bar-price');
      const original = bar.querySelector('.kaching-bundles__bar-full-price');
      const main = bar.querySelector('.kaching-bundles__bar-main');
      if (title?.textContent.includes('Sip-Paw')) title.textContent = title.textContent.replaceAll('Sip-Paw', 'Sip‑Paw');
      if (bar.dataset.dealBarId === '1zHr' && subtitle && subtitle.textContent.trim() !== singleOfferLabel) {
        subtitle.textContent = singleOfferLabel;
      }
      if (price) {
        price.dataset.a11yLabel = priceLabel;
        price.setAttribute('aria-label', `${priceLabel}: ${price.textContent.trim()}`);
      }
      if (original) {
        original.dataset.a11yLabel = originalPriceLabel;
        original.setAttribute('aria-label', `${originalPriceLabel}: ${original.textContent.trim()}`);
      }
      if (main) {
        const parts = [title?.textContent, subtitle?.textContent, price?.textContent, original?.textContent]
          .map((part) => part?.trim()).filter(Boolean);
        main.setAttribute('aria-label', parts.join('. '));
        main.setAttribute('aria-pressed', bar.classList.contains('kaching-bundles__bar--selected') ? 'true' : 'false');
      }

      bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').forEach((wrapper, index) => {
        const mainVariant = wrapper.querySelector('.kaching-bundles__bar-variant-main');
        if (!mainVariant) return;
        let itemLabel = mainVariant.querySelector('.sip-paw-v2__bundle-item-label');
        if (!itemLabel) {
          itemLabel = document.createElement('span');
          itemLabel.className = 'sip-paw-v2__bundle-item-label';
          mainVariant.prepend(itemLabel);
        }
        itemLabel.textContent = [bottleLabel, index + 1].join(' ');
        wrapper.querySelectorAll('.kaching-bundles-option-value').forEach((choice) => {
          const value = choice.dataset.value || choice.getAttribute('title') || '';
          choice.setAttribute('aria-label', `${bottleLabel} ${index + 1}, ${value}`);
          choice.setAttribute('aria-pressed', choice.classList.contains('kaching-bundles__swatch-buttons__button--selected') ? 'true' : 'false');
        });
        const image = wrapper.querySelector('.kaching-bundles__bar-variant-image');
        const selected = wrapper.querySelector('.kaching-bundles-option-value[aria-pressed="true"], .kaching-bundles__swatch-buttons__button--selected');
        if (image) image.alt = `${bottleLabel} ${index + 1} — ${selected?.dataset.value || ''}`.trim();
      });

      bar.querySelectorAll('.kaching-bundles__free-gift').forEach((gift) => {
        const copy = gift.querySelector('.kaching-bundles__free-gift__text')?.textContent.trim() || '';
        const image = gift.querySelector('.kaching-bundles__free-gift__image');
        if (image && copy) image.alt = copy;
      });
    });
  };

  const enhancePageAccessibility = (root) => {
    document.querySelectorAll('.splide__slide.is-clone').forEach((slide) => {
      slide.setAttribute('aria-hidden', 'true');
      slide.setAttribute('inert', '');
    });
    document.querySelectorAll('.scroll-to-top-btn').forEach((button) => {
      const label = root.dataset.scrollTopLabel || '';
      if (!button.getAttribute('aria-label') && label) button.setAttribute('aria-label', label);
    });
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('.sip-paw-v2')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('.sip-paw-v2'));
    roots.forEach((root) => {
      if (root.dataset.sipPawPageReady === 'true') return;
      root.dataset.sipPawPageReady = 'true';
      let queued = false;
      const run = () => {
        queued = false;
        enhanceBundle(root);
        enhancePageAccessibility(root);
      };
      const queue = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(run);
      };
      const observer = new MutationObserver(queue);
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      root._sipPawObserver = observer;
      queue();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('.sip-paw-v2').forEach((root) => root._sipPawObserver?.disconnect());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest?.('.sip-paw-v2');
    if (root) enhanceBundle(root);
  });
})();
